// extracted by mini-css-extract-plugin
export default {"brandPromo":"OF-z","carousel":"PF-z"};